<template>
    <v-app-bar
        app
        flat
        color="#F2F6FF">
        <v-app-bar-nav-icon
          @click="mostrarOcultarMenu">
        </v-app-bar-nav-icon>
        <v-toolbar-title>
          <span class="text-uppercase">
            CMCOP - HERMOSILLO
            <!-- <template v-if="!isSupervisionExterna">
              <template
                v-if="!$vuetify.breakpoint.mobile">
                Coordinación de Infraestructura, Desarrollo Urbano y Ecología
              </template>
              <template
                v-else>
                DGDI
              </template>
            </template>
            <template v-else>
              DGDI -
              {{ $auth.user.nombre }}
            </template> -->
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <menu-usuario></menu-usuario>
        <!-- <v-btn
          depressed
          rounded
          text
          :to="{ name: 'logout' }">
          <v-icon
            left>
            mdi-logout
          </v-icon>
          Salir
        </v-btn> -->
    </v-app-bar>
</template>

<script>
import eventBus from '@/helpers/eventBus';
import MenuUsuario from './MenuUsuario.vue';

export default {
  name: 'MainAppBar',
  components: {
    MenuUsuario,
  },
  data() {
    return {};
  },
  methods: {
    mostrarOcultarMenu() {
      eventBus.$emit('mostrar-ocultar-menu');
    },
  },
  computed: {
    isSupervisionExterna() {
      if (!this.$auth.user || !this.$auth.user?.roles) return false;
      return this.$auth.user.roles.includes('CONTRATISTA:SUPERVISION');
    },
  },
};
</script>

<style lang="scss">

</style>
